import "../buha-overlay/overlay";
import { replaceHtml } from "../../common/helper";

class BestelleinstiegStandort extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector(".standort-content");

    // Auswahl im Overlay: Snippet serverseitig neu laden (Cookie ist bereits gesetzt)
    this.addEventListener("filiale-gewaehlt", () => this.refreshSnippet());
  }

  async refreshSnippet() {
    const rohMatnr = this.dataset.matnr;
    if (!rohMatnr) {
      return; // ohne Matnummer kein Reload (defensiv gegen fehlerhaften Einbau)
    }
    try {
      const matnr = encodeURIComponent(rohMatnr);
      const response = await fetch(`/include/filialabholung/bestelleinstieg-standort?headless=true&matnr=${matnr}`, {
        method: "GET",
        credentials: "include",
        cache: "no-store",
        headers: { "Accept": "text/html" },
      });
      if (response.status === 200) {
        const html = await response.text();
        replaceHtml(this.content, html);
      } else {
        console.warn("bestelleinstieg-standort: Neuladen lieferte Status", response.status);
      }
    } catch (err) {
      console.error(err);
    }
  }
}

if (!customElements.get("bestelleinstieg-standort")) {
  customElements.define("bestelleinstieg-standort", BestelleinstiegStandort);
}
